// PA Dealing requests: the routes and the sidebar rows of `wealth.pa-dealing.requests` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.pa-dealing.requests',
    routes: [
        { frontend: 'desk', path: 'pa-dealing', lazy: () => import('@/pages/pa-dealing/page') },
        {
            frontend: 'desk',
            path: 'pa-dealing/new',
            lazy: () => import('@/pages/pa-dealing/new/page'),
        },
        {
            frontend: 'desk',
            path: 'pa-dealing/:id',
            lazy: () => import('@/pages/pa-dealing/request/page'),
        },
        { frontend: 'ops', path: 'pa-dealing', lazy: () => import('@/pages/pa-dealing/page') },
        {
            frontend: 'ops',
            path: 'pa-dealing/new',
            lazy: () => import('@/pages/pa-dealing/new/page'),
        },
        {
            frontend: 'ops',
            path: 'pa-dealing/:id',
            lazy: () => import('@/pages/pa-dealing/request/page'),
        },
        { frontend: 'comply', path: 'pa-dealing', lazy: () => import('@/pages/pa-dealing/page') },
        {
            frontend: 'comply',
            path: 'pa-dealing/new',
            lazy: () => import('@/pages/pa-dealing/new/page'),
        },
        {
            frontend: 'comply',
            path: 'pa-dealing/:id',
            lazy: () => import('@/pages/pa-dealing/request/page'),
        },
        { frontend: 'view', path: 'pa-dealing', lazy: () => import('@/pages/pa-dealing/page') },
        {
            frontend: 'view',
            path: 'pa-dealing/new',
            lazy: () => import('@/pages/pa-dealing/new/page'),
        },
        {
            frontend: 'view',
            path: 'pa-dealing/:id',
            lazy: () => import('@/pages/pa-dealing/request/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'pa-dealing',
            label: 'PA Dealing',
            href: '/comply/pa-dealing',
            icon: 'ArrowRightLeft',
            group: 'personal',
            order: 820,
        },
        // SEP-264 - the PA Dealing page of the employee. Each staff user asks for
        // clearance of their own personal account trades here. The same page is in
        // all four views, and an im-assistant sees it too.
        {
            frontend: 'desk',
            key: 'pa-dealing',
            label: 'PA Dealing',
            href: '/desk/pa-dealing',
            icon: 'ArrowRightLeft',
            group: 'personal',
            order: 620,
        },
        {
            frontend: 'ops',
            key: 'pa-dealing',
            label: 'PA Dealing',
            href: '/ops/pa-dealing',
            icon: 'ArrowRightLeft',
            group: 'personal',
            order: 710,
        },
        {
            frontend: 'view',
            key: 'pa-dealing',
            label: 'PA Dealing',
            href: '/view/pa-dealing',
            icon: 'ArrowRightLeft',
            group: 'personal',
            order: 710,
        },
    ],
});
